// A one-question modal: which item (or which item's log) does this action
// apply to? The fleet-wide Trips page asks it for Add and See All, because a
// card that merges every item's trips has no single item to act on.
//
// Deliberately dumb. It knows nothing about items or logbooks -- `choices`
// are `{ key, label, ...anything }` and `onChoose` gets the whole object back,
// so a caller can hang the item, the logbook, or both on a choice and read
// them off again. The "skip the modal when there is only one choice" rule is
// the caller's (AllTrips' `pick`), not this component's: a modal that
// sometimes doesn't open is harder to test than one that always does.
//
// ChooseLogbookModal is the obvious neighbour and is NOT reused: it always
// renders a create-a-new-logbook footer button, which this question has no
// answer for.
//
// Props:
//   show       - visibility
//   onHide     - Cancel / close, nothing chosen
//   title      - modal heading
//   prompt     - the line above the choices
//   choices    - [{ key, label, ... }]
//   onChoose(choice) - the user picked one (the caller closes the modal)

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const PickItemModal = ({ show, onHide, title, prompt, choices = [], onChoose }) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {prompt && <p className="text-body-secondary">{prompt}</p>}
      <div className="d-grid gap-2">
        {choices.map((choice) => (
          <Button key={choice.key} variant="outline-primary" onClick={() => onChoose(choice)}>
            {choice.label}
          </Button>
        ))}
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onHide}>
        Cancel
      </Button>
    </Modal.Footer>
  </Modal>
);

export default PickItemModal;
